import { lazy } from 'react';
import { Loadable } from './Loadable';
import { PATH_DASHBOARD } from './paths';

const logsRoutes = [
  {
    component: Loadable(lazy(() => import('../pages/historial/DetalleLogs'))),
    path: PATH_DASHBOARD.logs.detalle.path,
    shouldRender: PATH_DASHBOARD.logs.detalle.renderCondition,
  },
];

export default logsRoutes;
